define.alias("shared/utils/number-helpers/is-in-range", "calendar/utils/number-helpers/is-in-range");